"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportService = void 0;
var tslib_1 = require("tslib");
var notification_service_1 = require("../components/notification.toast/notification.service");
var i18n_1 = require("../i18n");
var index_1 = require("./index");
function handleError(e) {
    notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_EXPORT });
    return Promise.resolve(null);
}
var ExportService = /** @class */ (function () {
    function ExportService() {
        this.__priority = 100;
    }
    ExportService.prototype.export = function (type_1, selectorsByTag_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function (type, selectorsByTag, analyticName, noPhotos) {
            var units, time, count, timezone, startTime, data, result, e_1;
            if (analyticName === void 0) { analyticName = type; }
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        units = index_1.Services.UserSettings.units;
                        time = index_1.Services.DateTime.formatTimezoneDate();
                        count = this.getSelectorCount(selectorsByTag);
                        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        startTime = Date.now();
                        data = {
                            type: type,
                            tags: selectorsByTag,
                            time: time,
                            units: units,
                            timezone: timezone,
                            noPhotos: noPhotos
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, index_1.Services.Department.rest.Collection.export(data)];
                    case 2:
                        result = _a.sent();
                        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Export, analyticName, "".concat(count), Date.now() - startTime);
                        return [2 /*return*/, result];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, handleError(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ExportService.prototype.kml = function (selectorsByTag) {
        return this.export('KML', selectorsByTag, 'KML_V2');
    };
    ExportService.prototype.excel = function (selectorsByTag) {
        return this.export('EXCEL', selectorsByTag, 'EXCEL_V2');
    };
    ExportService.prototype.importableExcel = function (selectorsByTag) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.export('IMPORTABLE_EXCEL', selectorsByTag, 'EXCEL_IMPORTABLE')];
            });
        });
    };
    ExportService.prototype.json = function (selectorsByTag) {
        return this.export('JSON', selectorsByTag);
    };
    ExportService.prototype.ocalc = function (selectorsByTag) {
        return this.export('OCALC', selectorsByTag);
    };
    ExportService.prototype.spidacalc = function (selectorsByTag, noPhotos) {
        return this.export('SPIDACALC', selectorsByTag, 'SPIDACALC', noPhotos);
    };
    ExportService.prototype.poleforeman = function (selectorsByTag) {
        return this.export('POLEFOREMAN', selectorsByTag);
    };
    ExportService.prototype.ikePoleForeman = function (selectorsByTag) {
        return this.export('IKE_POLEFOREMAN', selectorsByTag);
    };
    ExportService.prototype.imageZip = function (selectorsByTag) {
        return this.export('IMAGE_ZIP', selectorsByTag);
    };
    ExportService.prototype.getSelectorCount = function (selectorsByTag) {
        return Object.keys(selectorsByTag).reduce(function (count, tagId) {
            return count += selectorsByTag[tagId].length;
        }, 0);
    };
    return ExportService;
}());
exports.ExportService = ExportService;
//# sourceMappingURL=export.service.js.map